import { RequirementReadDto } from "../../../Models/Requirement/RequirementReadDto";
import { FieldValidatorType } from "@progress/kendo-react-form";

export const nameValidator = (requirements: RequirementReadDto[], currentRequirement: RequirementReadDto | null = null): FieldValidatorType => (value: string) => {
  if (!value) {
    return "Name is required";
  }
  
  if (value.length < 2) {
    return "Name should be at least 2 characters long.";
  }

  // Skip validation if we're editing and the name hasn't changed
  if (currentRequirement && value.toLowerCase() === currentRequirement.name.toLowerCase()) {
    return "";
  }

  const duplicate = requirements?.some(requirement => 
    requirement.name.toLowerCase() === value.toLowerCase()
  );

  if (duplicate) {
    return "Name must be unique";
  }

  return "";
};

export const consumableValidator = (): FieldValidatorType => (value: any) =>
  !value
    ? "Consumable is required"
    : "";